/**
 * Renders views relating to permission modification.
 * @module app/routers/admin/Permissions
 */
import RouterBase from "app/routers/RouterBase";
import GroupCollection from "app/models/GroupCollection";
import UserCollection from "app/models/UserCollection";
import Index from "app/views/admin/permissions/Index";
import $ from "jquery";
import Viewer from "app/views/admin/permissions/Viewer";
import InverseViewer from "app/views/admin/permissions/InverseViewer";
import _ from "underscore";
import MapServiceCollection from "app/models/MapServiceCollection";
import LayoutCollection from "app/models/LayoutCollection";
import ErrorUtils from "app/utils/ErrorUtils";
import app from "app/App";
export default RouterBase.extend({
  root: "/admin/permissions",
  initialize: function (options) {
    RouterBase.prototype.initialize.apply(this, arguments);
  },

  load: function () {
    var deferred = new $.Deferred();
    var collection = (this.collection = new GroupCollection([]));

    collection.fetch({
      success: function () {
        deferred.resolve();
      },
      error: function (model, response) {
        deferred.reject(response);
      },
    });

    return deferred;
  },

  settings: {
    list: {
      title: "Global Permissions",
    },

    view: {
      title: "User/Group Permissions",
    },

    viewInverse: {
      title: "Layout/Service Access",
    },
  },

  routes: {
    "admin/permissions": "list",
    "admin/permissions/View": "view",
    "admin/permissions/ViewInverse": "viewInverse",
  },

  /**
   * Shows the global permission editor.
   */
  list: function () {
    var self = this;

    this.reload().done(
      _.bind(function () {
        var view = new Index({
          collection: self.collection,
        });

        view.render();
        app.pushView(view);
      })
    );
  },

  /**
   * Shows an interface which can be used to review permissions assigned to a given user.
   */
  view: function () {
    var self = this;
    this.loading();

    var users = new UserCollection([]);

    users.fetch({
      success: function () {
        var view = new Viewer({
          groups: self.collection,
          users: users,
        });

        view.render();
        app.pushView(view);

        self.doneLoading();
      },
      error: function (collection, response, options) {
        self.doneLoading();
        ErrorUtils.handleApiError(
          {
            activity: "loading user data",
          },
          collection,
          response,
          options
        );
      },
    });
  },

  /**
   * Shows an interface which can be used to review permissions assigned to a given services, layouts, maybe even layers within a service
   */
  viewInverse: function () {
    var self = this;
    this.loading();

    var mapServices = (this.mapServices = new MapServiceCollection([]));
    var layerConfiguration = (this.layerConfiguration = new LayoutCollection(
      []
    ));

    var deferred = mapServices.fetch({
      error: function (modelOrCollection, xhrError) {
        deferred.reject(xhrError);
      },
    });
    var deferredLayout = layerConfiguration.fetch({
      error: function (modelOrCollection, xhrError) {
        deferredLayout.reject(xhrError);
      },
    });

    $.when(deferred, deferredLayout)
      .then(function () {
        var view = new InverseViewer({
          groups: self.collection,
          mapServices: mapServices,
          layerConfiguration: layerConfiguration,
        });

        view.render();
        app.pushView(view);

        self.doneLoading();
      })
      .fail(
        ErrorUtils.errorHandler({
          activity: "loading permission data",
        })
      );
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/routers/admin/Permissions.js
// module id = 916
// module chunks = 1